import {
  icons,
  MenuItem,
  PermissionsPageAFY,
  sizesIcon,
  variantsAvatar,
} from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import React from "react";
import { ModalDelete } from "../sponsor/resorources/modalDelete";
import { CardProps } from "@affinitysystemsgroup/github-packages-affinity-components/dist/src/interfaces/interface";
import { insurersView, menuItem, statusPermission } from "./resource/data";

export const PermisionView = (props: {
  title: string;
  titleDrawer: string;
  list: CardProps[];
  avatarVariant: variantsAvatar;
  openModal: boolean;
  onSaveData?: any;
  // dataForm?: any[];
  modalTitle: string;
  editMode: boolean;
  clickView: (view: MenuItem) => void;
  onSubmit: () => void;
  onClose: () => void;
  onCloseSearch: () => void;
  openDrawer: boolean;
  setOpenDrawer: (value: boolean | (() => boolean)) => void;
  openModalDelete: boolean;
  setOpenModalDelete: (value: boolean | (() => boolean)) => void;

  onCloseDrawer: () => void;
  searchFilter: (term: any) => void;

  handleOpenModal: () => void;
  onClickContextMenu: (event: MenuItem, card: CardProps) => void;

  onClickAdd: () => void;
  onClickCancel: () => void;
  onFilterApply: (value: any) => void;
  onFilterEmpty: (value: any) => void;
  selectValueDefault: string;
  menuItem?: MenuItem[];

  inputHeigth?: string;
  clientFilterLbl?: string;

  /*Drawer Permissions*/
  columnsPermissions: any[];
  rowsPermissions: any[];

  countPagination: number;
  onChangePage: (e: number) => void;
  onChangeRowsPerPage: (e: number) => void;
  pageCatalog: number;
  limitCatalog: number;
}) => {
  return (
    <>
      <ModalDelete
        openModalConfirmDelete={props.openModalDelete}
        setOpenModalDelete={props.setOpenModalDelete}
        modalTitle={props.modalTitle}
        onClickDelete={props.onSubmit}
      />

      <PermissionsPageAFY
        avatarVariant={variantsAvatar.rounded}
        backgroundColorSearch={"#F6F7FB"}
        data={props.list}
        defaultOtherItems={[
          {
            id: "",
            name: "",
            value: "",
          },
        ]}
        descriptionDrawer="Agregue toda la información necesaria para crear permiso"
        dropdownStatusPermission={statusPermission}
        openDrawer={props.openDrawer}
        heightAddNew={113}
        heightCard="113px"
        heightGrid="calc(100vh - 233px )"
        iconAvatar={icons.Search}
        iconBgColor={"#F6F7FB"}
        iconColor={"#3A56A1"}
        iconColorSearch={"#3A56A1"}
        iconSearch={icons.Search}
        insurersView={insurersView}
        labelDropdownStatus="Estado"
        menuItem={menuItem}
        onClickAdd={props.onClickAdd}
        onClickContextMenu={props.onClickContextMenu}
        onCloseDrawer={props.onCloseDrawer}
        onChangeSearch={props.searchFilter}
        onCloseSearch={props.onCloseSearch}
        pageTitle="Permisos"
        pageTitleColor={"#0D0D0D"}
        placeholderTextSearch="Buscar"
        columnsTable={props.columnsPermissions}
        rowsTable={props.rowsPermissions}
        sizeIcon={sizesIcon.standard}
        sizesIconSearch={sizesIcon.standard}
        title2="Descripción:"
        titleButtonAdd="Guardar"
        titleClearButton="Limpiar filtros"
        titleDrawer=""
        titleDropdownSearch="Buscar"
        titleInputCloseSearch="Cerrar"
        titleSearchButton="Buscar"
        titleView="Vista"
        //paginationProps
        titlePagination={"Registros por página"}
        pagePagination={props.pageCatalog}
        countPagination={props.countPagination}
        onChangePage={props.onChangePage}
        onChangeRowsPerPage={props.onChangeRowsPerPage}
        rowsPerPage={props.limitCatalog}
        rowsPerPageOption={[20, 25, 50, 100]}
        showPagination
      />
    </>
  );
};